// extracted by mini-css-extract-plugin
export var dateLabel = "_4o-0";
export var dateLabelError = "_4o-1";
export var fullWidth = "_4o-2";
export var smaller = "_4o-3";